'use client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { env } from '@/constant/configs';

const WithReCaptcha = ({ children }: any) => {
  if (!env.re_captcha_key) {
    return <>{children}</>;
  }
  return (
    <GoogleReCaptchaProvider reCaptchaKey={env.re_captcha_key}>
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default WithReCaptcha;
